import { clearUserData } from "../../../utils/persist";
import userManager, { getIdentityLogoutUrl } from "../OIDCAuthHandler";

export class LogoutCommand {
  async execute() {
    clearUserData();
    try {
      await userManager.removeUser();
    } catch (error) {
      console.error("Failed to remove OIDC user:", error);
    }

    window.location.replace(getIdentityLogoutUrl());
  }
}
